import React, { useEffect } from "react";
import Button from "@mui/material/Button";
import LoadingButton from "@mui/lab/LoadingButton";
import { Box } from "@mui/material";
import { ClinicianDetailsFormStates, useClinicianDetailsForm } from "./ClinicianDetailsFormContext";

const ClinicianDetailsPageContentsButtons = (props) => {
  const { onCloseEditMode, submitButtonDisabled, onSubmitGlobalEdit, resetTab, currentTab } = props;

  const { onSubmit, loading, formState, resetState, onCancelEdit } = useClinicianDetailsForm();

  useEffect(() => {
    if (formState === ClinicianDetailsFormStates.submitSuccess) {
      resetTab();
      resetState();
    }
    if (formState === ClinicianDetailsFormStates.canceling) {
      onCancelEdit();
      onCloseEditMode(true);
      resetState();
    }
  }, [formState]);

  const handleSubmit = () => {
    if (currentTab === "insurance") {
      onSubmit();
    } else {
      onSubmitGlobalEdit();
    }
  };

  const handleCancel = () => {
    onCancelEdit();
    onCloseEditMode(true);
    resetState();
  };

  return (
    <Box display="flex" justifyContent="center">
      <Box width={"90%"} maxWidth={"1200px"}>
        <Box display={"flex"} flexDirection={"row"}>
          <Button
            color="secondary"
            size="medium"
            variant="contained"
            onClick={handleCancel}
            style={{ margin: "10px 0" }}
          >
            Cancel
          </Button>
          <LoadingButton
            size="medium"
            loading={loading}
            disabled={submitButtonDisabled || loading}
            onClick={handleSubmit}
            style={{ margin: "10px 20px" }}
          >
            Save Changes
          </LoadingButton>
        </Box>
      </Box>
    </Box>
  );
};

export default ClinicianDetailsPageContentsButtons;
